// extracted by mini-css-extract-plugin
module.exports = {"footer":"Foot_footer__113We","contactDeets":"Foot_contactDeets__1a45P","box":"Foot_box__2223l","socials":"Foot_socials__MyN0b","socialIcon":"Foot_socialIcon__27JYv"};